'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowUpRightIcon = function ArrowUpRightIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.051613,27.6369107 C5.58203139,28.1064923 4.82346788,28.1092711 4.34999207,27.6357951 L4.34999207,27.6357951 C3.87979438,27.1655974 3.88747432,26.3955764 4.34823002,25.9348208 L23.8750179,6.40803299 L16.3704518,6.40803299 C15.701082,6.40803299 15.1584506,5.87361245 15.1584506,5.20401649 L15.1584506,5.20401649 C15.1584506,4.53905649 15.7102915,4 16.366674,4 L26.7930697,4 C27.4603531,4 28.0012932,4.55184089 28.0012932,5.20822349 L28.0012932,15.6346191 C28.0012932,16.3019025 27.4668726,16.8428426 26.7972767,16.8428426 L26.7972767,16.8428426 C26.1323167,16.8428426 25.5932602,16.2956423 25.5932602,15.6265292 L25.5932602,8.09526352 L6.051613,27.6369107 L6.051613,27.6369107 Z' })
  );
};

ArrowUpRightIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ArrowUpRightIcon;